import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {CaseProcedureConfigurationModel} from '../../models/caseProcedures/case-procedure-configuration.model';
import {FormConfigurationModel} from '../../models/forms/form-configuration.model';
import {FormDeleteResponseModel} from '../../models/forms/form-delete-response.model';
import {CaseProcedureFormConfigurationModel} from '../../models/caseProcedures/case-procedure-form-configuration.model';
import {ProceduresService} from '../../modules/configuration/procedures/procedures.service';
import {
  ProceduresFormComponent,
  ProceduresFormData, ProceduresFormResult
} from '../../modules/configuration/procedures/procedures-form/procedures-form.component';

@Component({
  selector: 'app-procedure-form-mismatch-dialog',
  templateUrl: './procedure-form-mismatch-dialog.component.html',
  styleUrls: ['./procedure-form-mismatch-dialog.component.scss']
})
export class ProcedureFormMismatchDialogComponent implements OnInit {
  deletedForm: FormConfigurationModel;
  groupedByForm: CaseProcedureFormConfigurationModel[][] = [];
  constructor(@Inject(MAT_DIALOG_DATA) public data: FormDeleteResponseModel,
              private dialog: MatDialog,
              private matDialogRef: MatDialogRef<ProcedureFormMismatchDialogComponent>,
              private proceduresService: ProceduresService) {
    for (const proc of this.data.Procedures) {

    }

    data.Procedures.forEach((a) => {
      let formId = '';
      if (a.cfgCaseProcedureForms && a.cfgCaseProcedureForms.length > 0) {
        formId = a.cfgCaseProcedureForms[0].DFormId;
      }
      if (formId.length > 0) {
        this.groupedByForm[formId] = this.groupedByForm[formId] || [];
        this.groupedByForm[formId].push(a);
      }
    });

    console.log(this.groupedByForm);
  }

  ngOnInit(): void {
  }

  onCancelClick() {

  }

  onOkClick() {
    this.matDialogRef.close();
  }

  getProceduresForForm(DFormId: string) {
    return this.groupedByForm[DFormId] as CaseProcedureConfigurationModel[];
  }

  deleteFormFromAllProcedures(form: FormConfigurationModel) {
    // NEED TO BE ABLE TO DELETE MORE THAN ONE
    this.proceduresService.deleteProcedureFormsByDFormId(form.DFormId).subscribe(() => {
      this.matDialogRef.close();
    });
  }

  swapFormForProcedures(DFormId: string) {
    const d = new ProceduresFormData();
    d.isSingleSelectMode = true;
    const dialogRef = this.dialog.open(ProceduresFormComponent, {
      width: '805px',
      height: '725px',
      data: d
    });

    dialogRef.afterClosed().subscribe((result: ProceduresFormResult) => {
      if (result === null || result === undefined) { return; }
      const newId = result.selectedForms[0].DFormId;
      this.proceduresService.swapFormForProcedures(DFormId, newId).subscribe(() => {
        this.matDialogRef.close();
      });
    });
  }
}
